import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {
  isActive?: boolean;
}

const ServiceStackIcon: React.FC<SVGProps> = ({ isActive, style, ...props }) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = props?.fill?.trim() ? props?.fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";

  const mergedStyle: React.CSSProperties = {
    color: finalColor,
    ...(isActive
      ? {
          filter:
            "drop-shadow(0 0 1px rgba(21, 129, 237, 0.9)) drop-shadow(0 0 1px rgba(21, 129, 237, 0.9))",
        }
      : null),
    ...style,
  };

  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      style={mergedStyle}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.767486 12.8674C0.34345 12.8674 0 12.5233 0 12.0985V8.24632C0 8.2335 0 8.213 0.00127914 8.18672C0.0211059 6.70595 0.823129 5.32 2.09908 4.56648L8.83633 0.590613C10.1711 -0.196871 11.8295 -0.196871 13.1637 0.590613L19.9003 4.56648C21.1954 5.33089 22 6.74119 22 8.24632V12.0325C22 12.4573 21.6566 12.8014 21.2325 12.8014C20.8085 12.8014 20.465 12.4573 20.465 12.0325V8.24632C20.465 7.28327 19.9502 6.38045 19.1213 5.89155L12.3847 1.91569C11.5308 1.41142 10.4698 1.41142 9.61533 1.91569L2.87871 5.89155C2.05814 6.37596 1.54393 7.26853 1.53625 8.22069L1.53497 8.26041V12.0979C1.53497 12.5227 1.19152 12.8668 0.767486 12.8668V12.8674Z"
        fill="currentColor"
      />
      <path
        d="M10.1955 23.3712C10.1955 23.8633 9.65568 24.1638 9.23868 23.9043L1.96035 19.3761C0.825108 18.67 0.13501 17.4269 0.13501 16.089V14.4231C0.13501 14.1623 0.417701 14.0002 0.64219 14.1315L8.50957 18.7385C9.27322 19.2338 9.81621 19.9861 10.0567 20.8415C10.1194 21.0651 9.87697 21.2503 9.68062 21.1266L4.19693 17.6845C3.88546 17.4884 3.47422 17.5833 3.27915 17.8953C3.08344 18.2073 3.17809 18.6194 3.48957 18.8148L9.90127 22.8393C10.0842 22.954 10.1955 23.1552 10.1955 23.3712Z"
        fill="currentColor"
      />
      <path
        d="M11.804 23.3715C11.804 23.8636 12.3438 24.1641 12.7608 23.9046L20.0391 19.3764C21.1743 18.6703 21.8644 17.4273 21.8644 16.0894V14.4074C21.8644 14.1537 21.5894 13.9954 21.3707 14.1235L13.4899 18.7382C12.7262 19.2335 12.1832 19.9858 11.9427 20.8412C11.8801 21.0648 12.1225 21.25 12.3188 21.1263L17.8025 17.6842C18.114 17.4881 18.5252 17.583 18.7203 17.895C18.916 18.2071 18.8213 18.6191 18.5099 18.8145L12.0982 22.8391C11.9152 22.9538 11.804 23.1549 11.804 23.3709V23.3715Z"
        fill="currentColor"
      />
      <path
        d="M10.1838 17.1433C10.1838 17.6213 9.66195 17.9141 9.25454 17.6655L4.633 14.8366C3.57642 14.1901 2.93237 13.0387 2.93237 11.7988V9.50427C2.93237 9.21081 3.25536 9.03332 3.50287 9.19031L8.53439 12.3896C9.37926 12.9272 9.95104 13.7909 10.1263 14.7591C10.1576 14.9321 9.96767 15.0602 9.81928 14.9667L6.59136 12.9406C6.27286 12.7401 5.85266 12.8368 5.65311 13.1559C5.45293 13.475 5.5495 13.896 5.86865 14.0959L9.89795 16.6249C10.0764 16.7371 10.1838 16.9325 10.1838 17.1433Z"
        fill="currentColor"
      />
      <path
        d="M11.8161 17.1433C11.8161 17.6213 12.338 17.9141 12.7454 17.6655L17.3669 14.8366C18.4235 14.1901 19.0675 13.0387 19.0675 11.7988V9.50427C19.0675 9.21081 18.7446 9.03332 18.497 9.19031L13.4655 12.3896C12.6207 12.9272 12.0489 13.7909 11.8736 14.7591C11.8423 14.9321 12.0322 15.0602 12.1806 14.9667L15.4085 12.9406C15.7271 12.7401 16.1473 12.8368 16.3468 13.1559C16.547 13.475 16.4504 13.896 16.1313 14.0959L12.102 16.6249C11.9235 16.7371 11.8154 16.9325 11.8154 17.1433H11.8161Z"
        fill="currentColor"
      />
      <path
        d="M11.4515 4.65378L13.1655 5.66553C13.4367 5.82571 13.6036 6.1179 13.6036 6.43315V8.4874C13.6036 8.80265 13.4367 9.09483 13.1655 9.25502L12.4447 9.68048L11.4515 10.2668C11.1726 10.4314 10.8273 10.4314 10.5484 10.2668L8.83435 9.25502C8.56317 9.09483 8.39624 8.80265 8.39624 8.4874V6.43315C8.39624 6.43315 8.39624 6.42802 8.39624 6.42482C8.3988 6.11213 8.56509 5.82443 8.83371 5.66553L10.5478 4.65378C10.8266 4.48911 11.172 4.48911 11.4508 4.65378H11.4515Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ServiceStackIcon;
